import { z } from 'zod';

export const GroupSchema = z.object({
  id: z.number(),
  name: z.string(),
  include_in_reports: z.boolean(),
});
